import { render } from "./ScreenSettings.vue?vue&type=template&id=980fd01a&scoped=true"
import script from "./ScreenSettings.vue?vue&type=script&lang=js"
export * from "./ScreenSettings.vue?vue&type=script&lang=js"

import "./ScreenSettings.vue?vue&type=style&index=0&id=980fd01a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980fd01a"]])

export default __exports__